// extracted by mini-css-extract-plugin
export default {"control":"Control_control__odBV4","button":"Control_button__C0rpo"};